import type { ReactNode } from 'react'
import { SECTION_LABEL, SECTION_RULE } from './formModal.tokens'

/**
 * Section divider used across the form modals: an uppercase label, a rule that
 * fills the remaining width, and optional trailing content (e.g. a counter).
 */
export function FormSectionHeader({ title, children }: { title: string; children?: ReactNode }) {
  return (
    <div className="mb-3 flex items-center gap-3">
      <span className={SECTION_LABEL}>{title}</span>
      <span className={SECTION_RULE} />
      {children}
    </div>
  )
}
